export default __webpack_public_path__ + "static/1-aed07e6788f46a6303370435ae62c9d7.jpg";